// Module
var code = "<component :class=\"[{ '-skeleton' : show }]\" :is=\"element\"> <slot/> </component> ";
// Exports
export default code;